import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { API_KEY_FIELDS, mutateApiKeys } from './useGetApiKeys';

// `key` is the full key, in this response only: the API never shows it again.
export const CREATE_API_KEY = gql`
  mutation CreateApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      key
      api_key {
        ...apiKeyFields
      }
    }
  }
  ${API_KEY_FIELDS}
`;

// createApiKey({ name, scopes, expires_at? }) for this account resolves
// { success: true, data: { key, api_key } } or { success: false, error }.
export function useCreateApiKey(accountId) {
  const [mutate, { loading }] = useMutation(CREATE_API_KEY);
  const createApiKey = useCallback(
    (input) =>
      mutateApiKeys(
        mutate,
        accountId,
        { input: { account_id: accountId, ...input } },
        'createApiKey'
      ),
    [mutate, accountId]
  );
  return { createApiKey, loading };
}
